import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { TextFieldType } from '@/components/business/crud/interface/FieldType';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import EditText from '@/components/business/crud/common/EditText.vue';
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextTable',
  props: {
    columnEdit: { type: Function },
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

async function update(value: string) {
  if (!props.columnEdit) {
    return true
  }
  return props.columnEdit(props.data, props.propName, value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EditText, {
    value: _ctx.data[_ctx.propName],
    handler: _ctx.columnEdit ? update : undefined
  }, null, 8, ["value", "handler"]))
}
}

})